// styles
import {
  CareersWrapper,
  CareersEffect,
  CareersContent,
  Title,
  Copy,
  CareersButton,
} from './Careers.styles';

export function Careers({ content }) {
  return (
    <CareersWrapper>
      <CareersEffect intensity={0.55} phase={20} />
      <CareersContent>
        <Title>{content.title}</Title>
        <Copy>{content.description}</Copy>
        <CareersButton
          href={content.cta.url}
          {...(content.cta.external && {
            target: '_blank',
            rel: 'noreferrer noopener',
          })}
        >
          {content.cta.label}
        </CareersButton>
      </CareersContent>
    </CareersWrapper>
  );
}
